module.exports = __webpack_public_path__ + "media/france_bleu.efa9a5f2.mp4";